/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Invitations_Reminders_Over_CustomersInputs */

const en_queue_invitations_reminders_over_customers = /** @type {(inputs: Queue_Invitations_Reminders_Over_CustomersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer invitations not accepted after the reminders`)
};

/**
* | output |
* | --- |
* | "Customer invitations not accepted after the reminders" |
*
* @param {Queue_Invitations_Reminders_Over_CustomersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_invitations_reminders_over_customers = /** @type {((inputs?: Queue_Invitations_Reminders_Over_CustomersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Invitations_Reminders_Over_CustomersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_invitations_reminders_over_customers(inputs)
});